
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { AddButton, RemoveButton } from '../../reusableItems/buttons';
import { GoEye } from "react-icons/go";

import { TailSpin } from 'react-loading-icons'
import { sendRequest, API_ROOT } from '../../../../supplementary_components/requests';
import { addNotification, addPopup } from '../../../../supplementary_components/store';
import { ConfirmationDialogue } from '../../../forms/ConfirmationDialogue';
import { CustomAddForm} from '../../../forms/CustomAddForm';
import { checkForEmptyField } from "../../../forms/Form";
import { getDropBoxFiles } from '../../../forms/input_fields/inputFieldDelegate';

const FilesFrame = styled.div`
    // padding-bottom:2rem;
    
    // max-width:66%;
    min-width: 0;    /* override default min-width:auto */
    overflow: hidden;
    &>div:not(:last-child){
        margin-bottom:0.6rem;
        overflow:hidden;
        
        display:flex;
        align-items:center;
        .fileName{
            width: 80%;
            max-width: 80%;
            box-sizing: border-box;
            /* if long text/URLs: */
            overflow-wrap: anywhere;
            // max-width:10rem;
            overflow:hidden;
            cursor:default;
            color:var(--dark-gray);
            font-weight:bold;
        }
        .fileType{
            color:var(--lighter-gray);
            border:solid thin var(--lighter-gray);
            padding:0.1rem 0.3rem;
            border-radius:.3rem;
            margin: 0 0.5rem;
            align-items:flex-end;
            font-size: 0.8rem;
            cursor:default;
            margin-left: auto;
        }
        .downloadBtn{
            cursor:pointer;
            display:flex;
            justify-content:center;
            align-items:center;
            // 
            color:var(--main-color);
            svg{
                width:1.4rem;
                height:1.4rem;
            }
            padding-right:0.5rem;
        }
    }
    &>div:last-child{
        margin-top:2rem;
    }
`


export const FilesListing = ({files, loadId, setDataMethod})=>{
    const [fileList, setFileList] = useState(files);
    const [loadingItemIndex, setLoadingItemIndex] = useState(null);
    useEffect(() => {
        if(fileList !== files){
            setFileList(files);
        }
        return () => {
        }
        // eslint-disable-next-line
    }, [files])
     
    return <FilesFrame>
        {fileList.map((entry, index)=>{
            // Backend can store file entries as JSON strings; be tolerant if an entry is already a string label
            // (e.g. \"POD\") or an object.
            if(typeof entry === 'string'){
                const trimmed = entry.trim();
                if(trimmed.startsWith('{') || trimmed.startsWith('[')){
                    try {
                        entry = JSON.parse(trimmed);
                    } catch (e) {
                        entry = { fileName: trimmed, fileType: trimmed, filePath: null };
                    }
                }else{
                    entry = { fileName: trimmed, fileType: trimmed, filePath: null };
                }
            }else if(entry && typeof entry === 'object'){
                // keep as-is
            }else{
                entry = { fileName: 'Unknown', fileType: 'Unknown', filePath: null };
            }
            const FILE_NAME = entry['fileName'];
            return <div key={index}>
                <div className='fileName'>{FILE_NAME}</div>
                <div className='fileType'>{entry['fileType']}</div>
                <div className='downloadBtn' onClick={(e)=>{
                    if(!entry?.filePath) return;
                    setLoadingItemIndex(index);
                    const body = new FormData();
                    body.append("filePath", entry['filePath']); 
                    sendRequest('POST', API_ROOT+'loads/getFile',null,(res)=>{
                        res.blob().then(blob => {
                            const url = window.URL.createObjectURL(blob);
                            window.open(url);

                            // const url = window.URL.createObjectURL(blob);
                            // const a = document.createElement('a');
                            // a.style.display = 'none';
                            // a.href = url;
                            // a.download = entry['fileName'];
                            // document.body.appendChild(a);
                            // a.click();
                            // document.body.removeChild(a);
                            // window.URL.revokeObjectURL(url);
                            setLoadingItemIndex(null);
                        });
                    }, (e)=>{
                        // Error
                        addNotification({message:`Something went wrong`, type:'alert'});
                        setLoadingItemIndex(null);
                    }, body, {},(body)=>{return body}, true)
                }}>
                    {
                        loadingItemIndex === index ? <TailSpin stroke={'var(--light-gray)'} strokeWidth="0.2rem" width="1rem" height="1rem" speed = {1.5}	/> : <GoEye />
                    }
                </div>
                <RemoveButton action={()=>{
                    if(!entry?.filePath) return;
                    addPopup({
                        content:ConfirmationDialogue, 
                        popupData: {
                            action:(postResultAction)=>{
                                const body = new FormData();
                                body.append("filePath", entry['filePath']); 
                                body.append("loadId", loadId); 
                                sendRequest('POST', API_ROOT+'loads/removeFile',null,()=>{
                                    fileList.splice(index, 1);
                                    setFileList([...fileList]);
                                    postResultAction(true);
                                }, ()=>{
                                    // Error
                                    postResultAction(false);
                                    addNotification({message:`Something went wrong`, type:'alert'});
                                    // setLoadingState(false);
                                }, body, {},(body)=>{return body}, true);
                            },
                            name:"Confirm",
                            formTitle:"Delete File",
                            submitTitle:"Confirm",
                            method:"POST",
                            message:"Are you sure you want to delete this file?"
                        }, 
                        postSuccessAction: ()=>{
                        }, 
                        EZCloseAllowed:true
                    })
                }} />
            </div>
        })}
        <AddButton customSize={"1.6rem"} action={()=>{
            const InputFormData = {columns: [
                {
                    label: "File Type",
                    name: 'fileType',
                    type: 'select',
                    dataset: ["Proof Of Delivery", "Rate Confirmation", "Receipt"],
                    processBeforeSending : val => {
                        // return (parseInt(val));
                    }
                },
                {
                    label: "File",
                    name: 'selectedFile',
                    type: 'dropBox',
                    multiple: true,
                    imageEditor: true,
                    mandatory:true,
                    file: null,
                    files: [],
                },
            ]}
            addPopup({
                content:CustomAddForm, 
                popupData: {
                    action:(event, postResultAction)=>{
                        
                        event.preventDefault();
                        
                        const target = event.target;
                        if (checkForEmptyField(InputFormData, event)){return;}
                        const dropColumn = InputFormData.columns.find((clmn) => clmn.type === 'dropBox');
                        const selectedFiles = getDropBoxFiles(dropColumn);
                        if (!selectedFiles.length) {
                            return;
                        }
                        let mappedFileType = 'Unknown';
                        switch (target['fileType'].value) {
                            case 'Rate Confirmation':
                                mappedFileType = 'Rate Con';
                                break;
                            case "Proof Of Delivery": 
                                mappedFileType = 'POD';
                                break;
                            case "Receipt":
                                mappedFileType = 'Receipt';
                                break;
                            case "Invoice":
                                mappedFileType = 'Invoice';
                                break;
                            default:
                                mappedFileType = 'Unknown';
                                break;
                        }
                        const companyHeaders = {companyId:  parseInt(localStorage.getItem("currentCompanyId"))};
                        const uploadAt = (index, lastRes) => {
                            if (index >= selectedFiles.length) {
                                if (lastRes) {
                                    setDataMethod(lastRes);
                                }
                                postResultAction(true);
                                return;
                            }
                            const body = new FormData();
                            body.append("file", selectedFiles[index]);
                            body.append("fileName", selectedFiles[index].name);
                            body.append("loadId", loadId);
                            body.append("fileType", mappedFileType);
                            sendRequest('POST', API_ROOT+'loads/addFile',null,(res)=>{
                                    uploadAt(index + 1, res);
                                }, ()=>{
                                    if (index > 0 && lastRes) {
                                        setDataMethod(lastRes);
                                    }
                                    postResultAction(false);
                                    addNotification({
                                        message: index > 0
                                            ? `Uploaded ${index} of ${selectedFiles.length} files, then something went wrong`
                                            : `Something went wrong`,
                                        type:'alert'
                                    });
                                }, body, companyHeaders,(body)=>{return body}, false);
                        };
                        uploadAt(0, null);
                    },
                    name:"Confirm",
                    formTitle:"Add File",
                    submitTitle:"Add",
                    method:"POST",
                    columns: InputFormData['columns']
                }, 
                EZCloseAllowed:true
            })
        }} />
    </FilesFrame>
}
